import { Component, OnInit, Inject, Injectable } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-dialog',
  template: require('./dialog.component.html'),
  styles: [require('./dialog.component.css')]
})
export class DialogComponent implements OnInit {
  content: SafeHtml

  constructor(private dialogRef: MatDialogRef<DialogComponent>) { }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
